export const settings = {
  clientLogTimeout: 60 * 1000, // 60 seconds
  clientLogThreshold: 10,
  xsrfTokenCookie: 'XSRF-SA-TOKEN',
  xsrfTokenHeader: 'X-XSRF-SA-TOKEN',
  sessionTimeoutMax: 28800,
  supportedLanguages: ['en', 'es'],
  defaultLanguage: 'en',
  secondsToCacheLists: 3600,
  pingInterval: 60 * 1000, // 60 seconds
  i18nCache: false,
  prefix: 'sa',
} as const;
